var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusSmall = function SvgPlusSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.504 6.504h4.992v4.992c0 .274.23.504.504.504s.504-.23.504-.504V6.504h5c.266 0 .496-.23.496-.504a.51.51 0 0 0-.496-.504h-5v-5A.51.51 0 0 0 6 0a.51.51 0 0 0-.504.496v5H.504A.51.51 0 0 0 0 6c0 .274.23.504.504.504"
  })));
};
export default SvgPlusSmall;